export enum WebGebruikerGroep {
  Administrator = 1,
  Gemeente = 2,
  Waterschap = 3,
  Milieudienst = 4,
  Deskundige = 5,
  Deelnemer = 6,
  Toezichthouder = 7,
}
